import { User } from 'features/users/types';
import { useSystemSession } from 'hooks/useSystemSession';

export const useVisibleUserBadges = (user: User | undefined) => {
  const isSystemSession = useSystemSession();
  const showReaction = !!user?.reaction;
  const showHandRaise = !isSystemSession && !!user?.handRaised;

  return {
    showReaction,
    showHandRaise,
    count: Number(showReaction) + Number(showHandRaise),
  };
};
